import { render, staticRenderFns } from "./InnRadioGroup.vue?vue&type=template&id=d6ae5f52&"
import script from "./InnRadioGroup.vue?vue&type=script&lang=js&"
export * from "./InnRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports